/**
 * Cart shipping (woocommerce/cart/cart-shipping.php and
 * shipping-calculator.php), on top of WooCommerce's cart.js:
 *
 * - One rate change in flight at a time. cart.js posts every change and
 *   arrow keys can fire several before the first returns; the session then
 *   keeps whichever request lands last while the screen shows another.
 * - Picking a rate re-renders the summary; an open "Change address" panel
 *   comes back open with what was typed in it.
 * - After "Update rates" focus returns to the toggle instead of <body>.
 * - A cart restored from the back/forward cache is refreshed — the
 *   checkout may have changed the shipping choice since.
 * - A state field that country-select.js rebuilds keeps its form attribute.
 */

const RATE_SELECTOR = '.tx-cart__ship-option input.shipping_method';
const FORM_ID = 'tx-shipping-calculator';
const PANEL_ID = 'shipping-calculator-form';
const TOGGLE_SELECTOR = '.tx-cart__calc-toggle';
const FIELD_IDS = ['calc_shipping_state', 'calc_shipping_city', 'calc_shipping_postcode'];

const isBusy = () => !!document.querySelector('div.cart_totals.processing');

const readOpenPanel = () => {
    const panel = document.getElementById(PANEL_ID);
    if (!panel || panel.style.display === 'none') return null;

    const values = {};
    FIELD_IDS.forEach((id) => {
        const field = document.getElementById(id);
        if (field) values[id] = field.value;
    });
    return values;
};

const reopenPanel = ($, values) => {
    const panel = document.getElementById(PANEL_ID);
    const toggle = document.querySelector(TOGGLE_SELECTOR);
    if (!panel) return;

    panel.style.display = '';
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    // Lets country-select.js turn the now-visible state list into its widget.
    $(document.body).trigger('country_to_state_changed');

    FIELD_IDS.forEach((id) => {
        const field = document.getElementById(id);
        if (field && values[id] !== undefined && field.value !== values[id]) {
            field.value = values[id];
            $(field).trigger('change');
        }
    });
};

const init = () => {
    const $ = window.jQuery;
    if (!$ || !document.querySelector('.woocommerce-cart-form')) return;

    let queuedRateId = null;
    let panelValues = null;
    let refocusToggle = false;

    document.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.matches(RATE_SELECTOR)) return;

        if (isBusy()) {
            // Hold it back from cart.js until the change in flight returns.
            event.stopImmediatePropagation();
            queuedRateId = input.id;
            return;
        }
        panelValues = readOpenPanel();
    }, true);

    $(document.body).on('updated_shipping_method', () => {
        if (panelValues) reopenPanel($, panelValues);

        if (queuedRateId) {
            const input = document.getElementById(queuedRateId);
            queuedRateId = null;
            if (input) {
                panelValues = readOpenPanel();
                input.checked = true;
                $(input).trigger('change');
                return;
            }
        }
        panelValues = null;
    });

    document.addEventListener('submit', (event) => {
        if (event.target.id === FORM_ID) refocusToggle = true;
    }, true);

    $(document.body).on('updated_wc_div', () => {
        if (!refocusToggle) return;
        refocusToggle = false;

        // An error notice takes focus itself (role=alert).
        const focusIsLost = !document.activeElement || document.activeElement === document.body;
        if (focusIsLost && !document.querySelector('[role="alert"]')) {
            const toggle = document.querySelector(TOGGLE_SELECTOR);
            if (toggle) toggle.focus();
        }
    });

    $(document.body).on('country_to_state_changed', () => {
        const state = document.getElementById('calc_shipping_state');
        if (state && document.getElementById(FORM_ID) && !state.hasAttribute('form')) {
            state.setAttribute('form', FORM_ID);
        }
    });

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) $(document.body).trigger('wc_update_cart');
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
